<template>
  <div id="app">
    <router-view v-if="$root.routerShow"></router-view>
  </div>
</template>
<style />
<script>
import { Env } from './scripts/AllExport'
import Cookies from 'js-cookie'
export default {
  name: 'App',
  data: function () {
    return {
      routerShow: false
    }
  },
  beforeMount() {
    console.log('beforeCreate')
  },
  mounted() {
    this.init()
  },
  methods: {
    landing() {

    },
    timeout(ms) {
      return new Promise((resolve) => { setTimeout(resolve, ms) })
    },
    init() {
      let hl = this.$route.query.hl
      if (typeof hl !== 'undefined') {
        if (hl === 'zh' || hl === 'jp') {
          Cookies.set('language', hl, { path: '/', expires: Env.COOKIES_TTL })
          this.$i18n.locale = hl
        } else {
          Cookies.set('language', 'zh', { path: '/', expires: Env.COOKIES_TTL })
          this.$i18n.locale = 'zh'
        }
      } else {
        if (typeof Cookies.get('language') === 'undefined' || Cookies.get('language') === null) Cookies.set('language', 'zh', { path: '/', expires: Env.COOKIES_TTL })
      }
    }
  }
}
</script>

  <style scoped>
  #appLoadingAll{
      -webkit-transition: all 0.5s ease-in-out;
      -moz-transition: all 0.5s ease-in-out;
      -o-transition: all 0.5s ease-in-out;
      -ms-transition: all 0.5s ease-in-out;
      transition: all 0.5s ease-in-out;
      background-color:#000;
       height: 100vh;
      width: 100%;
  }
    @-webkit-keyframes appImgkeyframes {
      from {
        z-index: 11;
        opacity: 1;
      }
      to {
        z-index: 9;
      }
    }

    @keyframes appImgkeyframes {
      from {
        z-index: 11;
        opacity: 1;
      }
      to {
        z-index: 9;
      }
    }
    .appImg {
      z-index: 10;
      opacity: 1;
      height: 100vh;
      width: 100%;
      position: absolute;
      background-color: hsla(0, 0%, 100%, 0);
      object-fit: cover;

    }

    #appImg2 {
      -webkit-animation: appImgkeyframes 3.6s 0s ease-in-out;
      animation: appImgkeyframes 3.6s 0s ease-in-out;
    }
  </style>



// WEBPACK FOOTER //
// src/App.vue